import { render } from "./AvailableGames.vue?vue&type=template&id=9f07f948&scoped=true"
import script from "./AvailableGames.vue?vue&type=script&lang=js"
export * from "./AvailableGames.vue?vue&type=script&lang=js"

import "./AvailableGames.vue?vue&type=style&index=0&id=9f07f948&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f07f948"]])

export default __exports__